import { graphql, useStaticQuery } from "gatsby";

const ResourcesCategories = (language = "English") => {
    const resourceData = useStaticQuery(
        graphql`
            fragment ResourceCategories on ContentfulResourceConnection {
                Resource_Type: group(field: { resourceType: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                            languages
                            node_locale
                        }
                    }
                }
                Product_Interest: group(field: { productInterest: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                            languages
                            node_locale
                        }
                    }
                }
                Industries: group(field: { industry: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                            languages
                            node_locale
                        }
                    }
                }
                Topic: group(field: { topic: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                            languages
                            node_locale
                        }
                    }
                }
            }

            fragment TaxonomyTitles on ContentfulTaxonomy {
                terms {
                    ... on ContentfulResourceTerm {
                        name
                        title
                    }
                }
            }

            query allResourceCategoryData {
                EnglishResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "en" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                GermanResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "de-DE" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                SpanishResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "es-ES" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                FrenchResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "fr-FR" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                ItalianResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "it-IT" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                PortugueseResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "pt-BR" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                JapaneseResources: allContentfulResource(
                    sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                    filter: { node_locale: { eq: "ja-JP" }, languages: { ne: null } }
                ) {
                    ...ResourceCategories
                }
                EnglishTermTitles: contentfulTaxonomy(name: { eq: "Resource Taxonomies" }, node_locale: { eq: "en" }) {
                    ...TaxonomyTitles
                }
                GermanTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "de-DE" }
                ) {
                    ...TaxonomyTitles
                }
                SpanishTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "es-ES" }
                ) {
                    ...TaxonomyTitles
                }
                FrenchTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "fr-FR" }
                ) {
                    ...TaxonomyTitles
                }
                ItalianTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "it-IT" }
                ) {
                    ...TaxonomyTitles
                }
                PortugueseTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "pt-BR" }
                ) {
                    ...TaxonomyTitles
                }
                JapaneseTermTitles: contentfulTaxonomy(
                    name: { eq: "Resource Taxonomies" }
                    node_locale: { eq: "ja-JP" }
                ) {
                    ...TaxonomyTitles
                }
            }
        `
    );

    const allCategoryData = resourceData[`${language}Resources`];

    // Filter out all resources that shouldn't display in the current language.
    for (const [key, category] of Object.entries(allCategoryData)) {
        allCategoryData[key] = category.filter((subCategory) => {
            subCategory.edges = subCategory?.edges?.filter(
                ({ node }) => node?.languages?.includes("All") || node?.languages?.includes(language)
            );
            return subCategory?.edges?.length;
        });
    }

    return {
        allCategoryData: allCategoryData,
        categoryTerms: resourceData[`${language}TermTitles`],
    };
};

export default ResourcesCategories;
